import { gql } from '@apollo/client';
import { MATERIAL_REQUEST_FIELDS, PAGE_INFO_FIELDS } from './fragments';

// ============================================================================
// Queries
// ============================================================================

/**
 * Paginated material requests filtered by status.
 * Use fetchPolicy 'cache-and-network' for the DRAFT list to stay current.
 */
export const MATERIAL_REQUESTS_QUERY = gql`
  query MaterialRequests(
    $status: MaterialRequestStatus
    $first: Int
    $after: String
    $allCustomers: Boolean
    $customerNumbers: [String!]
  ) {
    materialRequests(status: $status, first: $first, after: $after, allCustomers: $allCustomers, customerNumbers: $customerNumbers) {
      edges {
        node {
          ...MaterialRequestFields
        }
        cursor
      }
      pageInfo {
        ...PageInfoFields
      }
      totalCount
    }
  }
  ${MATERIAL_REQUEST_FIELDS}
  ${PAGE_INFO_FIELDS}
`;

export const MATERIAL_REQUEST_QUERY = gql`
  query MaterialRequest($id: ID!, $allCustomers: Boolean, $customerNumbers: [String!]) {
    materialRequest(id: $id, allCustomers: $allCustomers, customerNumbers: $customerNumbers) {
      ...MaterialRequestFields
    }
  }
  ${MATERIAL_REQUEST_FIELDS}
`;

// ============================================================================
// Mutations
// ============================================================================

export const CREATE_MATERIAL_REQUEST_MUTATION = gql`
  mutation CreateMaterialRequest(
    $items: [MaterialRequestItemInput!]!
    $name: String
    $commission: String
    $desiredDeliveryDate: String
    $desiredDeliveryWeek: String
    $note: String
    $customerNumber: String
  ) {
    createMaterialRequest(
      items: $items
      name: $name
      commission: $commission
      desiredDeliveryDate: $desiredDeliveryDate
      desiredDeliveryWeek: $desiredDeliveryWeek
      note: $note
      customerNumber: $customerNumber
    ) {
      ...MaterialRequestFields
    }
  }
  ${MATERIAL_REQUEST_FIELDS}
`;

export const UPDATE_MATERIAL_REQUEST_MUTATION = gql`
  mutation UpdateMaterialRequest(
    $id: ID!
    $name: String
    $items: [MaterialRequestItemInput!]
    $commission: String
    $desiredDeliveryDate: String
    $desiredDeliveryWeek: String
    $note: String
    $customerNumber: String
  ) {
    updateMaterialRequest(
      id: $id
      name: $name
      items: $items
      commission: $commission
      desiredDeliveryDate: $desiredDeliveryDate
      desiredDeliveryWeek: $desiredDeliveryWeek
      note: $note
      customerNumber: $customerNumber
    ) {
      ...MaterialRequestFields
    }
  }
  ${MATERIAL_REQUEST_FIELDS}
`;

export const SUBMIT_MATERIAL_REQUEST_MUTATION = gql`
  mutation SubmitMaterialRequest($id: ID!, $customerNumber: String) {
    submitMaterialRequest(id: $id, customerNumber: $customerNumber) {
      ...MaterialRequestFields
    }
  }
  ${MATERIAL_REQUEST_FIELDS}
`;

export const CANCEL_MATERIAL_REQUEST_MUTATION = gql`
  mutation CancelMaterialRequest($id: ID!, $customerNumber: String) {
    cancelMaterialRequest(id: $id, customerNumber: $customerNumber) {
      ...MaterialRequestFields
    }
  }
  ${MATERIAL_REQUEST_FIELDS}
`;

export const DELETE_MATERIAL_REQUEST_MUTATION = gql`
  mutation DeleteMaterialRequest($id: ID!, $customerNumber: String) {
    deleteMaterialRequest(id: $id, customerNumber: $customerNumber)
  }
`;
